import { Box, Skeleton } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import {
	getDashboardServices,
	getDashboardServicesLoader,
} from 'redux/reducers/dashboard/selectors';
import { PpwrBanner } from '../PpwrBanner';
import { PpwrSubMenu } from '../PpwrSubMenu';

export const PpwrSkeleton: FC = () => (
	<Box sx={{ margin: '0px 10px 0 10px' }}>
		<Skeleton variant="rectangular" height={530} />
	</Box>
);

type TPpwrLayoutProps = {
	children: ReactNode;
};

// Wraps PPWR sub-pages: shows the sub menu and the page content for merchants
// with PPWR enabled, otherwise the PPWR advertising banner.
export const PpwrLayout: FC<TPpwrLayoutProps> = ({ children }) => {
	const dashboardServices = useSelector(getDashboardServices);
	const dashboardServicesIsLoad = useSelector(getDashboardServicesLoader);

	if (dashboardServicesIsLoad && !dashboardServices) return <PpwrSkeleton />;

	if (!dashboardServices?.ppwrEnabled) return <PpwrBanner />;

	return (
		<>
			<PpwrSubMenu />
			{children}
		</>
	);
};
